/*
 * @Author: kangzhuang 742291831@qq.com
 * @Date: 2025-04-17 11:17:13
 * @LastEditors: kangzhuang 742291831@qq.com
 * @LastEditTime: 2025-05-07 09:04:19
 * @FilePath: \qrcode-web\src\api\code.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/request";

// 登录状态下的访问记录
export const loginRecords = data => {
	return request.post("/home/qrcode_records", data);
};

// 登录状态下更新访问记录访问记录
export const updateRecords = data => {
	return request.post("/home/edit_qrcode_records", data);
};

// 未登录状态下的访问记录
export const logoutRecords = data => {
	return request.post("/qrcode_record", data);
};
